import React, { Component } from "react";

export default class FullStackImg extends Component {
  render() {
    // const theme = this.props.theme;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="736.078"
        height="461.657"
        data-name="Layer 1"
        viewBox="0 0 736.078 461.657"
      >
        <path
          fill="#f2f2f2"
          d="M254.961 439.163a2.807 2.807 0 01-2.035-4.866l.193-.764-.077-.184a7.54 7.54 0 00-13.906.052c-2.275 5.478-5.17 10.965-5.884 16.758a22.304 22.304 0 00.392 7.67 89.42 89.42 0 01-8.134-37.139 86.307 86.307 0 01.535-9.628q.444-3.931 1.23-7.806a90.456 90.456 0 0117.939-38.338 24.073 24.073 0 0010.012-10.387 18.363 18.363 0 001.67-5.018c-.488.064-1.838-7.36-1.47-7.815-.68-1.03-1.896-1.543-2.637-2.548-3.69-5.002-8.773-4.13-11.427 2.668-5.668 2.861-5.723 7.606-2.245 12.17 2.213 2.903 2.517 6.831 4.459 9.94-.2.255-.408.503-.608.759a91.04 91.04 0 00-9.502 15.053 37.846 37.846 0 00-2.26-17.578c-2.162-5.218-6.216-9.612-9.785-14.122-4.288-5.417-13.08-3.053-13.836 3.814l-.021.2q.795.449 1.557.952a3.808 3.808 0 01-1.536 6.93l-.077.012a37.89 37.89 0 00.998 5.665c-4.579 17.71 5.308 24.16 19.425 24.45.311.16.615.32.927.472a92.926 92.926 0 00-5.002 23.54 88.137 88.137 0 00.064 14.23l-.024-.168a23.29 23.29 0 00-7.95-13.447c-6.119-5.026-14.763-6.877-21.363-10.917a4.37 4.37 0 00-6.694 4.252l.027.177a25.578 25.578 0 012.868 1.382q.795.449 1.557.952a3.808 3.808 0 01-1.535 6.93l-.078.012-.16.024a37.923 37.923 0 006.976 10.923c2.863 15.46 15.162 16.927 28.317 12.425h.008a92.897 92.897 0 006.24 18.218h22.294c.08-.248.151-.504.223-.752a25.329 25.329 0 01-6.168-.367c1.654-2.03 3.308-4.075 4.962-6.105a1.384 1.384 0 00.104-.12c.839-1.038 1.686-2.069 2.525-3.108a37.101 37.101 0 00-1.087-9.452zM525.662 233.529H17.092A17.112 17.112 0 010 216.437V17.092A17.112 17.112 0 0117.092 0h508.57a17.112 17.112 0 0117.092 17.092v199.345a17.112 17.112 0 01-17.092 17.092z"
        ></path>
        <path
          fill="#fff"
          d="M407.052 222.628H97.82a87.014 87.014 0 01-86.916-86.916V97.826A87.015 87.015 0 0197.82 10.91h347.117a87.015 87.015 0 0186.916 86.916 124.943 124.943 0 01-124.8 124.802z"
        ></path>
        <path
          fill="#e6e6e6"
          d="M327.283 67.976H122.876a4.408 4.408 0 110-8.816h204.407a4.408 4.408 0 010 8.816zM430.757 115.006h-307.88a4.408 4.408 0 110-8.816h307.88a4.408 4.408 0 010 8.816zM430.757 162.037h-307.88a4.408 4.408 0 110-8.816h307.88a4.408 4.408 0 010 8.816z"
        ></path>
        <path
          fill="#e6e6e6"
          d="M430.757 162.037h-307.88a4.408 4.408 0 110-8.816h307.88a4.408 4.408 0 010 8.816zM400.956 81.14c2.82-15.361 9.408-28.811 20.99-39.728a3.434 3.434 0 014.636-1.43l30.004 15.851a3.434 3.434 0 011.43 4.636l-20.99 39.728a3.434 3.434 0 01-4.635 1.43l-30.004-15.851a3.434 3.434 0 01-1.43-4.635z"
        ></path>
        <path
          fill="#fff"
          d="M409.598 70.357c.37-8.019 6.218-16.695 13.494-25.541a3.216 3.216 0 014.341-1.34l25.786 13.623a3.216 3.216 0 011.34 4.341L435.88 96.794a3.216 3.216 0 01-4.342 1.34l-15.973-8.44a14.326 14.326 0 01-5.968-19.337z"
        ></path>
        <path
          fill="#6c63ff"
          d="M439.877 75.473L419.74 64.906a1.364 1.364 0 011.268-2.416l20.136 10.567a1.364 1.364 0 01-1.268 2.416zM427.648 60.605l-4.43-2.325a1.364 1.364 0 111.268-2.416l4.43 2.325a1.364 1.364 0 01-1.268 2.416zM434.302 86.095l-20.135-10.567a1.364 1.364 0 011.268-2.416L435.57 83.68a1.364 1.364 0 01-1.268 2.416zM437.09 80.784l-20.136-10.567a1.364 1.364 0 111.268-2.416l20.136 10.567a1.364 1.364 0 01-1.268 2.416z"
        ></path>
        <path
          fill="#f2f2f2"
          d="M617.922 350.744h-10.416a3.75 3.75 0 00-3.75 3.75 3.75 3.75 0 01-3.75 3.75h-34.723a3.75 3.75 0 01-3.75-3.75l-.687-3.802.044.052-.044-.052-6.295-8.024a2.184 2.184 0 00-1.749-.85H541a2.225 2.225 0 00-2.223 2.223l-.244 6.651h-4.462a7.137 7.137 0 00-7.137 7.137v46.484a6.334 6.334 0 006.333 6.334h84.656a6.34 6.34 0 006.331-6.334v-47.237a6.332 6.332 0 00-6.331-6.332z"
        ></path>
        <path
          fill="#e6e6e6"
          d="M560.849 350.52h-22.073v-6.65a2.225 2.225 0 012.223-2.223h11.803a2.184 2.184 0 011.75.85z"
        ></path>
        <path
          fill="#fff"
          d="M572.151 405.532h-36.856a4.405 4.405 0 01-4.4-4.4v-10.08a4.405 4.405 0 014.4-4.4h44.236a4.405 4.405 0 014.4 4.4v2.7a11.794 11.794 0 01-11.78 11.78z"
        ></path>
        <path
          fill="#f2f2f2"
          d="M545.904 394.255h-9.097a2.231 2.231 0 110-4.463h9.097a2.231 2.231 0 110 4.463zM576.8 401.292h-39.993a2.231 2.231 0 110-4.463H576.8a2.231 2.231 0 110 4.463z"
        ></path>
        <path
          fill="#f2f2f2"
          d="M654.922 401.744h-10.416a3.75 3.75 0 00-3.75 3.75 3.75 3.75 0 01-3.75 3.75h-34.723a3.75 3.75 0 01-3.75-3.75l-.687-3.802.044.052-.044-.052-6.295-8.024a2.184 2.184 0 00-1.749-.85H578a2.225 2.225 0 00-2.223 2.223l-.244 6.651h-4.462a7.137 7.137 0 00-7.137 7.137v46.484a6.334 6.334 0 006.333 6.334h84.656a6.34 6.34 0 006.331-6.334v-47.237a6.332 6.332 0 00-6.331-6.332z"
        ></path>
        <path
          fill="#e6e6e6"
          d="M597.849 401.52h-22.073v-6.65a2.225 2.225 0 012.223-2.223h11.803a2.184 2.184 0 011.75.85z"
        ></path>
        <path
          fill="#fff"
          d="M609.151 456.532h-36.856a4.405 4.405 0 01-4.4-4.4v-10.08a4.405 4.405 0 014.4-4.4h44.236a4.405 4.405 0 014.4 4.4v2.7a11.794 11.794 0 01-11.78 11.78z"
        ></path>
        <path
          fill="#f2f2f2"
          d="M582.904 445.255h-9.097a2.231 2.231 0 110-4.463h9.097a2.231 2.231 0 110 4.463zM613.8 452.292h-39.993a2.231 2.231 0 110-4.463H613.8a2.231 2.231 0 110 4.463z"
        ></path>
        <path
          fill="#ffb6b6"
          d="M489.468 444.144L480.868 444.143 476.777 410.972 489.47 410.972 489.468 444.144z"
        ></path>
        <path
          fill="#2f2e41"
          d="M463.51 456.833a3.658 3.658 0 003.636 3.642h16.189l.502-1.04 2.29-4.725.886 4.725.197 1.04h6.106l-.087-1.047-1.629-19.526-2.13-.131-9.203-.545-2.26-.138v5.83c-1.716 1.825-15.18 8.723-14.496 11.915z"
        ></path>
        <path
          fill="#ffb6b6"
          d="M631.857 377.722L627.7 385.251 596.682 372.802 602.817 361.69 631.857 377.722z"
        ></path>
        <path
          fill="#2f2e41"
          d="M630.421 406.58a3.658 3.658 0 004.945-1.423l7.824-14.173-.668-.942-3.03-4.288 4.566 1.507 1.005.33 2.95-5.345-.958-.43-17.882-8.01-1.143 1.8-4.925 7.795-1.214 1.912 5.104 2.818c.769 2.384.302 17.504 3.426 18.448zM503.858 225.515l32.495 13.797s10.396 22.195 3.206 25.376v58.677l74.223 42.955-22.372 37.37s-28.716-7.418-28.416-14.19 3.61-9.45-6.25-10.32-15.444-.143-15.176-6.186-34.822-37.464-34.822-37.464z"
        ></path>
        <path
          fill="#2f2e41"
          d="M511.643 236.78l-8.24-9.256s-18.505 30.386-18.435 36.627-15.708 38.428-15.708 38.428l-19.564 114.86s37.735 8.97 40.64 9.218 7.805 1.78 4.724-4.035 0-5.814 0-5.814l1.894-88.434 14.689-60.824z"
        ></path>
        <path
          fill="#6c63ff"
          d="M507.322 147.803l15.777-3.787 9.124 11.191a33.871 33.871 0 0110.043 31.117l-8.438 43.522s15.147 13.884 13.253 21.457c-3.07 12.283-36.936 1.436-42.765 2.296s-13.403-8.572-14.665-13.954 3.886-18.298 5.68-18.003-4.95-26.72-4.95-26.72.532-18.089 6.843-23.137a34.934 34.934 0 009.238-11.569z"
        ></path>
        <path
          fill="#ffb6b6"
          d="M438.822 79.566a7.326 7.326 0 008.58 7.134l19.86 30.643 9.825-3.41-23.854-36.222a7.316 7.316 0 00-14.41 1.855z"
        ></path>
        <path
          fill="#6c63ff"
          d="M518.463 186.389s7.48-16.014 1.79-23.131-9.846-14.353-13.029-16.313-15.871-24.654-19.069-25.332-.713-4.356-5.178-6.33-5.748-1.99-5.733-3.272-10.888-16.677-10.888-16.677l-11.207 6.957 27.377 56.005z"
        ></path>
        <path
          fill="#e6e6e6"
          d="M447.807 336.246c-14.338-19.07-22.625-40.395-22.896-64.708a5.246 5.246 0 013.192-6.688l48.87-17.291a5.246 5.246 0 016.687 3.192l22.896 64.708a5.246 5.246 0 01-3.192 6.688l-48.87 17.291a5.246 5.246 0 01-6.687-3.192z"
        ></path>
        <path
          fill="#fff"
          d="M444.64 315.375c-8.623-8.718-12.314-24.269-14.72-41.6a4.913 4.913 0 012.99-6.264l41.999-14.86a4.913 4.913 0 016.263 2.99l20.374 57.581a4.913 4.913 0 01-2.99 6.264l-26.017 9.205a21.884 21.884 0 01-27.9-13.316z"
        ></path>
        <path
          fill="#6c63ff"
          d="M481.735 286.66l-32.717 11.678a2.084 2.084 0 01-1.4-3.926l32.715-11.678a2.084 2.084 0 111.402 3.926zM452.373 285.004l-7.197 2.569a2.084 2.084 0 01-1.401-3.926l7.197-2.57a2.084 2.084 0 011.401 3.927zM487.895 303.92l-32.716 11.677a2.084 2.084 0 11-1.401-3.926l32.716-11.678a2.084 2.084 0 111.401 3.926zM484.815 295.29l-32.716 11.678a2.084 2.084 0 11-1.402-3.926l32.717-11.678a2.084 2.084 0 011.401 3.926z"
        ></path>
        <circle cx="509.235" cy="125.157" r="16.939" fill="#ffb6b6"></circle>
        <path
          fill="#2f2e41"
          d="M491.423 122.946a4.918 4.918 0 003.05.815 12.398 12.398 0 00.118-3.934 15.11 15.11 0 011.437 3.732c3.013-.657 2.879-1.553 5.983-1.084a6.35 6.35 0 014.797 7.955c.657-1.44 3.389-.786 3.85.862.48 1.734-.577 3.486-1.59 4.974-3.614 5.32 5.735 15.124 2.12 20.443l-.504.601a54.065 54.065 0 008.928-5.83 17.475 17.475 0 01-.243-6.404 8.167 8.167 0 002.734 4.486c10.228-8.02 22.531-19.566 20.269-22.368l-6.885-12.136c-7.236-12.748-24.686-17.87-35.498-7.97-.282.264-.923.089-1.208.366-3.106.805-7.082 2.263-9.111 4.746-2.022 2.487-.902 8.954 1.753 10.746z"
        ></path>
        <path
          fill="#e6e6e6"
          d="M504.675 254.126c-13.781-7.349-24.597-17.709-31.483-32.058a3.434 3.434 0 01.043-4.851l24.211-23.777a3.434 3.434 0 014.851.043l31.484 32.058a3.434 3.434 0 01-.044 4.851l-24.21 23.778a3.434 3.434 0 01-4.852-.044z"
        ></path>
        <path
          fill="#fff"
          d="M497.023 242.619c-7.528-2.787-14.02-10.992-20.24-20.61a3.216 3.216 0 01.04-4.543l20.808-20.434a3.216 3.216 0 014.543.04L530.19 225.6a3.216 3.216 0 01-.041 4.543l-12.89 12.659a14.326 14.326 0 01-20.236-.183z"
        ></path>
        <path
          fill="#6c63ff"
          d="M511.088 215.32l-16.18 15.98a1.364 1.364 0 11-1.917-1.942l16.18-15.979a1.364 1.364 0 111.917 1.942zM493.21 222.46l-3.56 3.516a1.364 1.364 0 01-1.917-1.942l3.56-3.515a1.364 1.364 0 111.917 1.941zM519.518 223.857l-16.18 15.978a1.364 1.364 0 11-1.918-1.941l16.18-15.979a1.364 1.364 0 111.918 1.942zM515.303 219.589l-16.18 15.978a1.364 1.364 0 11-1.918-1.941l16.18-15.979a1.364 1.364 0 011.918 1.942z"
        ></path>
        <path
          fill="#ffb6b6"
          d="M480.617 287.328a7.326 7.326 0 016.974-8.71l13.312-34.002 10.31 1.37-16.106 40.27a7.316 7.316 0 01-14.49 1.072z"
        ></path>
        <path
          fill="#6c63ff"
          d="M537.219 166.705s10.538 14.189 6.393 22.302-6.769 16.036-9.494 18.594-10.605 27.336-13.602 28.641.175 4.412-3.804 7.242-5.231 3.101-4.96 4.354-7.323 18.521-7.323 18.521l-12.374-4.568 26.35-91.658z"
        ></path>
        <path
          fill="#cacaca"
          d="M734.887 461.657l-662.75-.693a1.19 1.19 0 010-2.381l662.75.692a1.19 1.19 0 110 2.382z"
        ></path>
        <path
          fill="#e6e6e6"
          d="M248.983 199.381c-7.848-13.503-11.589-28.005-9.888-43.83a3.434 3.434 0 012.59-4.102l33.103-7.468a3.434 3.434 0 014.101 2.591l9.889 43.831a3.434 3.434 0 01-2.592 4.101l-33.102 7.468a3.434 3.434 0 01-4.1-2.59z"
        ></path>
        <path
          fill="#fff"
          d="M248.536 185.57c-4.933-6.333-6.132-16.727-6.358-28.179a3.216 3.216 0 012.427-3.84l28.449-6.419a3.216 3.216 0 013.84 2.427l8.8 39.004a3.216 3.216 0 01-2.427 3.84l-17.623 3.976a14.326 14.326 0 01-17.108-10.81z"
        ></path>
        <path
          fill="#6c63ff"
          d="M259.601 164.04a4.099 4.099 0 014.797-1.046 4.21 4.21 0 012.146 4.577c-.312 2.063-1.39 3.941-1.487 6.054a5.202 5.202 0 002.241 4.786c1.175.713 2.384-1.053 1.204-1.77-1.942-1.18-1.29-3.773-.726-5.542.703-2.209 1.436-4.46.566-6.736a6.146 6.146 0 00-10.148-1.936c-.927 1 .469 2.625 1.407 1.613z"
        ></path>
        <circle cx="269.029" cy="182.439" r="2.14" fill="#6c63ff"></circle>
        <path
          fill="#e6e6e6"
          d="M59.776 106.16c-7.848-13.504-11.589-28.006-9.889-43.832a3.434 3.434 0 012.591-4.1l33.103-7.469a3.434 3.434 0 014.1 2.591l9.89 43.831a3.434 3.434 0 01-2.592 4.101l-33.102 7.468a3.434 3.434 0 01-4.101-2.59z"
        ></path>
        <path
          fill="#fff"
          d="M59.328 92.347c-4.932-6.333-6.131-16.726-6.357-28.178a3.216 3.216 0 012.427-3.84l28.448-6.419a3.216 3.216 0 013.841 2.427l8.8 39.003a3.216 3.216 0 01-2.427 3.841l-17.624 3.976a14.326 14.326 0 01-17.108-10.81z"
        ></path>
        <circle cx="74.197" cy="92.32" r="3" fill="#6c63ff"></circle>
        <path
          fill="#6c63ff"
          d="M77.782 63.828c-1.154-1.354-3.267-1.139-5.015-.806a20.66 20.66 0 00-5.272 1.501 6.958 6.958 0 00-3.689 3.877c-.698 2.142.063 4.468.975 6.528a44.04 44.04 0 006.916 10.92l1.43.663a27.01 27.01 0 005.529-20.24 4.67 4.67 0 00-.874-2.443z"
        ></path>
      </svg>
    );
  }
}
